export function arrayHasElements<T>(array: T[]) {
    return array.length > 0;
}

export function enforceArray<T>(arrayOrItem: T[] | T): T[] {
    return Array.isArray(arrayOrItem) ? arrayOrItem : [arrayOrItem];
}
